"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.severityPillColors = exports.tokenPillColors = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _customPropTypes = require("../helpers/customPropTypes");

var _RawButton = require("../RawButton");

var _RawButton2 = _interopRequireDefault(_RawButton);

require("./Pill.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Pill = function (_Component) {
  _inherits(Pill, _Component);

  function Pill() {
    _classCallCheck(this, Pill);

    return _possibleConstructorReturn(this, (Pill.__proto__ || Object.getPrototypeOf(Pill)).apply(this, arguments));
  }

  _createClass(Pill, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          ariaLabel = _props.ariaLabel,
          children = _props.children,
          className = _props.className,
          color = _props.color,
          isDisabled = _props.isDisabled,
          onClick = _props.onClick,
          size = _props.size,
          moreProps = _objectWithoutProperties(_props, ["ariaLabel", "children", "className", "color", "isDisabled", "onClick", "size"]);

      var rootClasses = (0, _classnames2.default)("aclui-pill", className, "aclui-pill--" + size, "aclui-pill--" + color, {
        "aclui-pill--clickable": onClick
      });
      var tabIndex = onClick === null ? -1 : 0;

      if (onClick) {
        return _react2.default.createElement(
          _RawButton2.default,
          _extends({
            ariaLabel: ariaLabel,
            className: rootClasses,
            isDisabled: isDisabled,
            onClick: onClick,
            tabIndex: tabIndex
          }, moreProps),
          this.props.children
        );
      }

      return _react2.default.createElement(
        "div",
        _extends({ className: rootClasses, tabIndex: tabIndex }, moreProps),
        this.props.children
      );
    }
  }]);

  return Pill;
}(_react.Component);

var tokenPillColors = exports.tokenPillColors = ["black", "black-lighten-60", "blue", "green-darken-10", "orange-darken-10"];
var severityPillColors = exports.severityPillColors = ["no-risk", "low-risk", "medium-risk", "high-risk"];

Pill.propTypes = {
  ariaLabel: _propTypes.string,
  buttonRef: _propTypes.func,
  children: _propTypes.node.isRequired,
  className: _propTypes.string,
  color: (0, _propTypes.oneOf)([].concat(tokenPillColors, severityPillColors)),
  isDisabled: _propTypes.bool,
  onClick: _propTypes.func,
  role: _propTypes.string,
  size: _customPropTypes.shirtSize
};

Pill.defaultProps = {
  ariaLabel: null,
  className: null,
  color: "black-lighten-60",
  isDisabled: false,
  onClick: null,
  role: null,
  size: "medium"
};

exports.default = Pill;